import { cva } from 'class-variance-authority';

export const badgeVariants = cva(
  'inline-flex items-center rounded-md border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'text-foreground',
      },
      size: {
        small: 'px-1.5 py-0.25 text-[10px]', // Small size
        medium: 'px-2.5 py-0.5 text-xs', // Default medium size
        large: 'px-3 py-1 text-sm', // Optional large size
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'medium', // Default size is medium
    },
  }
);
